import { FormInstance } from "antd";
import { FC } from "react";
import OrganizationSelectionSetting from "../OrganizationSelectionSetting";
type PropsType = {
  form: FormInstance;
  getFieldClassName?: (name: string) => string;
};

const BranchSelectionSetting: FC<PropsType> = ({ form, getFieldClassName }) => {
  return (
    <OrganizationSelectionSetting
      form={form}
      modelName="branch"
      getFieldClassName={getFieldClassName}
    />
  );
};

export default BranchSelectionSetting;
